import { render } from "./UploadRequestForm.vue?vue&type=template&id=1b675ef5&scoped=true"
import script from "./UploadRequestForm.vue?vue&type=script&lang=js"
export * from "./UploadRequestForm.vue?vue&type=script&lang=js"

import "./UploadRequestForm.vue?vue&type=style&index=0&id=1b675ef5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b675ef5"]])

export default __exports__